<template>
  <div class="this-Part">
    <div class="this-Part-Play">

      <div class="this-Part-Text">
        <p>&#10148;{{$t('i.search.legalConstitution')}}</p>
      </div>
      <div class="line"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "law"
  }
</script>

<style scoped>
  .this-Part{
    width: 100%;
    height: 90px;
  }

  .this-Part-Play{
    width: 1050px;
    height: 90px;
    margin: 0 auto;
    padding-top: 1px;
  }

  .this-Part-Text{
    margin-top: 25px;
  }

  .this-Part-Text p{
    font-size: 20px;
  }

  .line{
    width: 918px;
    height: 1px;
    background-color: #c7c7c7;
    margin-top: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/search/components/law.vue